import { render } from "./activity.vue?vue&type=template&id=1f2ffd66&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"

import "./activity.vue?vue&type=style&index=0&id=1f2ffd66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2ffd66"]])

export default __exports__